import { render } from "./index.vue?vue&type=template&id=a6f7c948&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a6f7c948&lang=scss&scoped=true"

import exportComponent from "/Users/canfengchen/eclipse-workspace/gsjy/dxzjapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6f7c948"]])

export default __exports__